import { ResponsivePie } from "@nivo/pie";
import { useTranslation } from "react-i18next";
import { byActivatedTheme, useNivoTheme } from "../../../../common/theme";
import { CountByActivated } from "../../../../common/pagination";
import { Box } from "@mui/material";

interface AssociateByActivatedChartDatum {
  id: string;
  label: string;
  value: number;
  activated: boolean;
}

const AssociatesByActivated = (props: { data?: CountByActivated }) => {
  const { t } = useTranslation();
  const titleActive = t("reports.organization.associates.activation.active");
  const titleAuto = t("reports.organization.associates.activation.auto");
  const countActive = props.data?.active ?? 0;
  const countAuto = props.data?.auto ?? 0;

  const chartData: AssociateByActivatedChartDatum[] = [
    {
      id: titleActive,
      label: `${titleActive} (${countAuto})`,
      value: countActive,
      activated: true,
    },
    {
      id: titleAuto,
      label: `${titleAuto} (${countAuto})`,
      value: countAuto,
      activated: false,
    },
  ];

  return (
    <>
      <Box textAlign={"center"}>
        {t("reports.organization.associates.activation.title")}
      </Box>
      <ResponsivePie
        margin={{ top: 10, right: 0, bottom: 80, left: 0 }}
        data={chartData}
        animate={true}
        enableArcLabels={false}
        enableArcLinkLabels={false}
        activeInnerRadiusOffset={6}
        layers={["arcs", "legends"]}
        colors={byActivatedTheme.palette.pie}
        theme={useNivoTheme()}
        legends={[
          {
            anchor: "bottom-left",
            direction: "column",
            symbolShape: "circle",
            itemWidth: 100,
            itemHeight: 20,
            translateY: 50,
            translateX: 30,
            effects: [
              {
                on: "hover",
                style: {
                  itemOpacity: 0.5,
                },
              },
            ],
          },
        ]}
      />
    </>
  );
};

export default AssociatesByActivated;
